<template>
	<div class="home-page-container">
		<div class="custom-home-background"></div>
		<div class="home-page-content">
			<div class="home-page-col">
				<router-link :to="'/page/3'" class="hp-page-link">
					<div class="hp-page-link-text">
						{{ getPage(3).title[language] }}
					</div>
					<div class="hp-page-image">
						<img :src="`${storagePath}wir_mono.png`" alt="" class="no-hover">
						<img :src="`${storagePath}wir_color.png`" alt="" class="hover">
					</div>
				</router-link>
			</div>
			<div class="home-page-sep"></div>
			<div class="home-page-col">
				<router-link :to="'/page/2'" class="hp-page-link">
					<div class="hp-page-link-text">
						{{ getPage(2).title[language] }}
					</div>
					<div class="hp-page-image">
						<img :src="`${storagePath}dig_mono.png`" alt="" class="no-hover">
						<img :src="`${storagePath}dig_color.png`" alt="" class="hover">
					</div>
				</router-link>
			</div>
			<div class="home-page-sep"></div>
			<div class="home-page-col">
				<router-link :to="'/page/1'" class="hp-page-link">
				<div class="hp-page-link-text">
					{{ getPage(1).title[language] }}
				</div>
					<div class="hp-page-image">
						<img :src="`${storagePath}dat_mono.png`" alt="" class="no-hover">
						<img :src="`${storagePath}dat_color.png`" alt="" class="hover">
					</div>
				</router-link>
			</div>
		</div>

		<div class="gdpr-menu-container">
			<GenericMenu :menuArray="footerMenu"/>
		</div>
	</div>
</template>

<script>
import contentDataLoaderMixin from '@/store/modules/contentData/content-data-loader';
import staticDataLoaderMixin from '@/store/modules/staticData/static-data-loader';
import featureSetLoaderMixin from '@/store/modules/featureSet/feature-set-loader';
import PostsView from '@/views/PostsView.vue';
import GenericMenu from '@/components/GenericMenu.vue';

export default {
	name: 'HomePage',
	mixins: [contentDataLoaderMixin, staticDataLoaderMixin, featureSetLoaderMixin],
	components: { PostsView, GenericMenu },
	data() {
		return {};
	},
	created() {
		this.$root.$emit('resetCoverImages');
	},
	computed: {
		getPage() {
			return (pageId) => {
				const page = { ...this.getContentById('pages', pageId) };
				page.title = JSON.parse(page.title);
				return page;
			};
		},
	},

};
</script>

<style src="#/styles/views/HomePage/HomePage.less" lang="less" scoped></style>
